import { Injectable } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { SupplementaryEquipmentDetails } from '../model/supplementary-equipment-details';
import { Observable } from 'rxjs';
import { ServiceResponse } from '@sdbn/common';
import { Identity } from '@sdbn/common';
import { SupplementaryEquipment } from '../model/supplementary-equipment';

@Injectable({
  providedIn: 'root'
})
export class SupplementaryEquipmentService {

  constructor(private appServerAPI: AppServerAPI) { }

  getSupplementaryEquipment(): Observable<SupplementaryEquipment[]> {
    return this.appServerAPI.execute<SupplementaryEquipment[]>('/client/admin/supplementaryequipment', {});
  }

  getSupplementaryEquipmentDetails(identity: Identity): Observable<SupplementaryEquipmentDetails> {
    return this.appServerAPI.execute<SupplementaryEquipmentDetails>('/client/admin/supplementaryequipment/details', identity);
  }

  saveSupplementaryEquipment(se: SupplementaryEquipmentDetails): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/supplementaryequipment/save', se);
  }

  createSupplementaryEquipment(se: SupplementaryEquipmentDetails): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/supplementaryequipment/create', se);
  }

  deleteSupplementaryEquipment(identity: Identity): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/supplementaryequipment/delete', identity);
  }
}
